import './vendors.scss';
import 'angular';
import 'angular-animate';
import 'angular-route';
import 'angular-sanitize';
// import 'angular-cookies';
import './vendor/angular-locale_pt-br';
/*
 @link https://github.com/McNull/angular-block-ui
 */
import 'angular-block-ui/dist/angular-block-ui';

/*
 @link https://github.com/danialfarid/ng-file-upload
 */
import 'ng-file-upload';